import { Component, ElementRef, OnInit, Optional, Type, ViewChild } from '@angular/core';
import { NbDialogRef, NbDialogService, NbMenuService } from '@nebular/theme';
import { GridInputDialogComponent } from './grid-input-dialog/grid-input-dialog.component';
import { RendererType } from '@urbannex/storethemes';
import { PreviewEditStoreService } from '../../../../services/preview-edit-store.service';
import { Page } from '../../../../editor-container/editor-model';
import { IframeCommunicationService } from '../../../../services/iframe-communication.service';
import { EditorService } from '../../../services/editor.service';

@Component({
  selector: 'kve-home-input-grid',
  templateUrl: './home-input-grid.component.html',
  styleUrls: ['./home-input-grid.component.scss']
})
export class HomeInputGridComponent implements OnInit {
  activeInputMenuItem: string;
  title: string;
  collapsed: boolean = true;

  @ViewChild('expandable', { read: ElementRef }) expandable: ElementRef<HTMLElement>

  constructor(
    @Optional() protected ref: NbDialogRef<HomeInputGridComponent>,
    private menuService: NbMenuService,
    private el: ElementRef<HTMLElement>,
    private dialogService: NbDialogService,
    private editorService: EditorService,
    private previewEditStoreService: PreviewEditStoreService,
    private communicator: IframeCommunicationService,
  ) { }

  ngOnInit(): void {
    this.menuService.onItemClick().subscribe(menuBag => {
      const selectedItem = menuBag.item;
      if (selectedItem != undefined) {
        this.activeInputMenuItem = selectedItem.title;
      }
    })
  }

  ngAfterViewInit(): void {
    const overlayPane = this.findNearestParentWithClass(
      this.el.nativeElement,
      'grid-picker'
    );
    if (overlayPane) {
      // console.log('Found parent:', parentElement);
      const overlayWrapper = overlayPane.parentElement;
      setTimeout(() => {
        overlayWrapper.style.left = "0px";
        overlayWrapper.style.justifyContent = "flex-end";
        overlayWrapper.style.right = "16px";
        // overlayPane.style.width = "256px";
        overlayPane.style.marginRight = "16px";
        overlayPane.style.marginTop = "18px";
        overlayPane.style.display = "block";
      }, 1);
    }
    // const overlayPane = this.el.nativeElement.parentElement.parentElement;
    // const overlayWrapper = this.el.nativeElement.parentElement.parentElement.parentElement;



    // return el.parentElement.parentElement.parentElement.parentElement;
  }

  private findNearestParentWithClass(
    element: HTMLElement,
    className: string
  ): HTMLElement | null {
    return element.closest(`.${className}`) as HTMLElement | null;
  }

  toggleContainer() {
    this.expandable.nativeElement.classList.toggle("collapsed");
  }

  close(e) {
    console.log("closing dialog", e);
    this.editorService.notifyDialogClose(e);
    this.ref.close();
  }

  createGrid(numberOfCells: number) {
    const component: Type<any> = GridInputDialogComponent;
    const layoutClass = "grid-" + numberOfCells;

    console.log(layoutClass)

    this.dialogService.open(component, {
      context: {
        rendererType: RendererType.GRID,
        layoutClass: layoutClass,
        title: "Adding new section with grid layout"
      }
    }).onClose.subscribe(() => {
      console.log("closing")
      /* this.previewEditStoreService.selectedPage$.subscribe((page:Page) => {
        console.log(page);
        if(page != null && page != undefined){
          this.communicator.sendFromParent({id:"selectedPage",data:page});
        }

      }) */
    })
    this.ref.close();
  }

}
